import gql from 'graphql-tag';

export const installationQuery = gql`
  query installation($organizationId: Long) {
    installation(organizationId: $organizationId) {
      answers
      updatedAt
      updatedBy
    }
  }
`;

export const installationPhotosQuery = gql`
  query installationPhotos($organizationId: Long) {
    installationPhotos(organizationId: $organizationId) {
      fileName
      label
      url
      section
    }
  }
`;

export const installationPhotoUploadRequestQuery = gql`
  query installationPhotoUploadRequest(
    $organizationId: Long
    $section: String!
    $fileName: String!
    $contentType: String!
  ) {
    installationPhotoUploadRequest(
      organizationId: $organizationId
      section: $section
      fileName: $fileName
      contentType: $contentType
    ) {
      url
      fileName
    }
  }
`;

export const updateInstallationSectionMutation = gql`
  mutation updateInstallationSection($organizationId: Long, $section: String!, $answers: Json!) {
    updateInstallationSection(organizationId: $organizationId, section: $section, answers: $answers) {
      answers
      updatedAt
      updatedBy
    }
  }
`;

export const confirmInstallationPhotoUploadMutation = gql`
  mutation confirmInstallationPhotoUpload(
    $organizationId: Long
    $section: String!
    $fileName: String!
    $label: String
  ) {
    confirmInstallationPhotoUpload(
      organizationId: $organizationId
      section: $section
      fileName: $fileName
      label: $label
    ) {
      answers
    }
  }
`;

export const updateInstallationPhotoLabelMutation = gql`
  mutation updateInstallationPhotoLabel(
    $organizationId: Long
    $section: String!
    $fileName: String!
    $label: String
  ) {
    updateInstallationPhotoLabel(
      organizationId: $organizationId
      section: $section
      fileName: $fileName
      label: $label
    ) {
      answers
    }
  }
`;

export const removeInstallationPhotoMutation = gql`
  mutation removeInstallationPhoto($organizationId: Long, $section: String!, $fileName: String!) {
    removeInstallationPhoto(organizationId: $organizationId, section: $section, fileName: $fileName) {
      answers
    }
  }
`;
